module.exports = __webpack_public_path__ + "img/man-band-aid.b6fa2f61.png";